<section
  class="sticky top-0 w-full z-50 navbarTop pb-8"
  #pygNavigation
  [class.pygBgActive]="pygBgActive()"
  [@navAnime]="navAnimeTrigger()"
  [@navBlogAnime]="navBlogAnimeTrigger()"
>
  <div class="max-w-screen-2xl mx-auto">
    <div
      class="w-10/12 sm:w-9/12 mx-auto flex flex-nowrap justify-between relative"
      [@navWidthAnime]="navigationWidth()"
    >
      <img
        [src]="
          pygBgActive()
            ? 'assets/img/Shared/pygmalios-logo-white.svg'
            : 'assets/img/Shared/pygmalios-logo.svg'
        "
        class="w-40 sm:w-44 md:w-48 lg:w-52 outline-hidden cursor-pointer"
        langRouterLink
        (click)="toElement('instore')"
      />
      <div class="flex">
        <div class="pt-1 lg:flex lg:ml-3 xl:ml-6 hidden my-auto">
          <!-- Solutions dropdown -->
          <div
            class="cursor-pointer ml-3 xl:ml-5 relative pygDropdown pygSolutions"
            (clickOutside)="closeSolutionsDropdown()"
            (mouseenter)="openSolutionsDropdown()"
            (mouseleave)="scheduleSolutionsClose()"
          >
            <p
              [class.active]="activeSiteSection() | sectionActive: 'solutions'"
              [class.inactiveProducts]="productsIsActive()"
              [class.pygSolutionsOpen]="solutionsOpen()"
            >
              {{ "navigation.solutions" | translate }}
            </p>
            @if (solutionsOpen()) {
              <div class="pygMegaMenu absolute bg-white -ml-4 p-6" [@menuAnime]>
                <div class="flex gap-8">
                  <div class="min-w-48">
                    <p class="pygMenuHeading mb-3">{{ "navigation.saas_products" | translate }}</p>
                    <a
                      langRouterLink="solutions"
                      class="pygMenuItem block py-2"
                      (click)="closeSolutionsDropdown()"
                    >{{ "navigation.traffic_analytics" | translate }}</a>
                    <a
                      langRouterLink="solutions"
                      class="pygMenuItem block py-2"
                      (click)="closeSolutionsDropdown()"
                    >{{ "navigation.journey_analytics" | translate }}</a>
                    <a
                      langRouterLink="solutions"
                      class="pygMenuItem block py-2"
                      (click)="closeSolutionsDropdown()"
                    >{{ "navigation.queue_occupancy" | translate }}</a>
                  </div>
                  <div class="min-w-48">
                    <p class="pygMenuHeading mb-3">{{ "navigation.innovation_services" | translate }}</p>
                    <a
                      langRouterLink="innovation"
                      class="pygMenuItem flex items-center py-2"
                      (click)="closeSolutionsDropdown()"
                    >
                      {{ "navigation.innovation" | translate }}
                      <img
                        src="assets/img/Shared/arrow-right.svg"
                        alt=""
                        class="ml-2 w-4 h-4"
                      />
                    </a>
                  </div>
                </div>
              </div>
            }
          </div>

          <div
            class="cursor-pointer ml-3 xl:ml-5"
            langRouterLink="platform"
          >
            <p
              [class.active]="activeSiteSection() | sectionActive: 'platform'"
              [class.inactiveProducts]="productsIsActive()"
            >
              {{ "navigation.platform" | translate }}
            </p>
            @if (
              (activeSiteSection() | sectionActive: "platform") && !navChange()
            ) {
              <hr [@hrAnime] />
            }
          </div>

          <div
            class="cursor-pointer ml-3 xl:ml-5"
            langRouterLink="case-studies"
          >
            <p
              [class.active]="activeSiteSection() | sectionActive: 'case-studies'"
              [class.inactiveProducts]="productsIsActive()"
            >
              {{ "navigation.case_studies" | translate }}
            </p>
            @if (
              (activeSiteSection() | sectionActive: "case-studies") && !navChange()
            ) {
              <hr [@hrAnime] />
            }
          </div>

          <div
            class="cursor-pointer ml-3 xl:ml-5"
            langRouterLink="about"
          >
            <p
              [class.active]="activeSiteSection() | sectionActive: 'about'"
              [class.inactiveProducts]="productsIsActive()"
            >
              {{ "navigation.about" | translate }}
            </p>
            @if (
              (activeSiteSection() | sectionActive: "about") && !navChange()
            ) {
              <hr [@hrAnime] />
            }
          </div>

          <div class="cursor-pointer ml-3 xl:ml-5" langRouterLink="blog">
            <p
              [class.active]="activeSiteSection() | sectionActive: 'blog'"
              [class.inactiveProducts]="productsIsActive()"
            >
              {{ "navigation.blog" | translate }}
            </p>
            @if (
              (activeSiteSection() | sectionActive: "blog") && !navChange()
            ) {
              <hr [@hrAnime] />
            }
          </div>
        </div>

        <div class="flex">
          @if (activeSiteSection() === "blog" && navChange()) {
            <button
              class="font-bold rounded-l-full rounded-r-full hidden lg:block w-full h-16 lg:h-12 lg:w-40 ml-3 xl:ml-5"
              [@btnAnime]
              (click)="toogleSubscribeForm()"
            >
              {{ "buttons.subscribe" | translate }}
            </button>
          }

          <app-get-demo class="hidden lg:block ml-3 xl:ml-5"></app-get-demo>

          <div class="ml-4 pl-1 pygDropdown hidden lg:block relative my-auto">
            <div class="flex justify-between">
              <p class="active">{{ activeLanguage() }}</p>
              <img
                src="assets/img/Shared/chevron.svg"
                alt=""
                class="chevron mr-3 mt-0.5"
              />
            </div>
            <div class="pygItems hidden absolute bg-white -ml-1 pl-1">
              @for (lang of languages; track lang) {
                <div
                  class="flex justify-between cursor-pointer"
                  (click)="setLanguage(lang)"
                >
                  @if (activeLanguage() !== lang) {
                    <p>
                      {{ lang }}
                    </p>
                  }
                  @if (activeLanguage() !== lang) {
                    <img
                      src="assets/img/Flags/{{ lang }}.svg"
                      alt=""
                      class="w-5 h-4 mr-3 my-auto border"
                    />
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      <img
        [src]="`assets/img/Shared/${menuImg()}`"
        alt="Menu"
        class="block lg:hidden cursor-pointer p-5 -mr-5"
        (click)="openMenu()"
      />

      @if (subscribeOpened()) {
        <div class="pygPopup" (clickOutside)="focusOut()" [@menuAnime]>
          <app-popup-subscribe
            [place]="'blog navigation'"
          ></app-popup-subscribe>
        </div>
      }
    </div>
  </div>

  @if (menuOpen()) {
    <div
      class="w-10/12 sm:w-9/12 mx-auto"
      [@menuAnime]="menuOpen()"
    >
      <!-- Solutions accordion -->
      <div>
        <div
          class="flex justify-between cursor-pointer"
          (click)="toggleMobileSolutions()"
        >
          <p
            class="p-3 my-3 -ml-2"
            [class.active]="activeSiteSection() | sectionActive: 'solutions'"
          >
            {{ "navigation.solutions" | translate }}
          </p>
          <img
            src="assets/img/Shared/arrow-right.svg"
            alt="arrow"
            [class.rotate-90]="mobileSolutionsOpen()"
            class="transition-transform"
          />
        </div>
        @if (mobileSolutionsOpen()) {
          <div class="pl-6 pb-2">
            <p class="pygMenuHeading py-2">{{ "navigation.saas_products" | translate }}</p>
            <div (click)="hideMenu()">
              <a
                langRouterLink="solutions"
                class="block py-2 pygMenuItem"
              >{{ "navigation.traffic_analytics" | translate }}</a>
              <a
                langRouterLink="solutions"
                class="block py-2 pygMenuItem"
              >{{ "navigation.journey_analytics" | translate }}</a>
              <a
                langRouterLink="solutions"
                class="block py-2 pygMenuItem"
              >{{ "navigation.queue_occupancy" | translate }}</a>
            </div>
            <p class="pygMenuHeading py-2 mt-2">{{ "navigation.innovation_services" | translate }}</p>
            <div (click)="hideMenu()">
              <a
                langRouterLink="innovation"
                class="block py-2 pygMenuItem"
              >{{ "navigation.innovation" | translate }}</a>
            </div>
          </div>
        }
      </div>
      <hr />

      <div
        class="flex justify-between cursor-pointer"
        langRouterLink="platform"
        (click)="hideMenu()"
      >
        <p
          class="p-3 my-3 -ml-2"
          [class.active]="activeSiteSection() | sectionActive: 'platform'"
        >
          {{ "navigation.platform" | translate }}
        </p>
        <img src="assets/img/Shared/arrow-right.svg" alt="arrow" />
      </div>
      <hr />

      <div
        class="flex justify-between cursor-pointer"
        langRouterLink="case-studies"
        (click)="hideMenu()"
      >
        <p
          class="p-3 my-3 -ml-2"
          [class.active]="activeSiteSection() | sectionActive: 'case-studies'"
        >
          {{ "navigation.case_studies" | translate }}
        </p>
        <img src="assets/img/Shared/arrow-right.svg" alt="arrow" />
      </div>
      <hr />

      <div
        class="flex justify-between cursor-pointer"
        langRouterLink="about"
        (click)="hideMenu()"
      >
        <p
          class="p-3 my-3 -ml-2"
          [class.active]="activeSiteSection() | sectionActive: 'about'"
        >
          {{ "navigation.about" | translate }}
        </p>
        <img src="assets/img/Shared/arrow-right.svg" alt="arrow" />
      </div>
      <hr />

      <div
        class="flex justify-between cursor-pointer"
        langRouterLink="blog"
        (click)="hideMenu()"
      >
        <p
          class="p-3 my-3 -ml-2"
          [class.active]="activeSiteSection() | sectionActive: 'blog'"
          [class.inactiveProducts]="productsIsActive()"
        >
          {{ "navigation.blog" | translate }}
        </p>
        <img src="assets/img/Shared/arrow-right.svg" alt="arrow" />
      </div>
      <hr />

      <div class="pygLanguages lg:hidden flex max-w-md -ml-2 my-3">
        @for (lang of languages; track lang) {
          <div class="cursor-pointer mr-4" (click)="setLanguage(lang)">
            <p [class.active]="activeLanguage() === lang">
              {{ lang }}
            </p>
            <img
              src="assets/img/Flags/{{ lang }}.svg"
              alt=""
              class="w-5 h-4 ml-2 border"
            />
          </div>
        }
      </div>
    </div>
  }
</section>
